import React from 'react';
import { SEOHead } from '@components/seo';
import dynamic from 'next/dynamic';
import { useAuth } from '@hooks/useAuth';

const HomeLoggedIn = dynamic(
  () => {
    const promise = import('@screens/home/homeLoggedIn').then(
      (mod) => mod.HomeLoggedIn,
    );
    return promise;
  },
  { ssr: true, loading: () => null },
);

const HomeLoggedOut = dynamic(
  () => {
    const promise = import('@screens/home/homeLoggedOut').then(
      (mod) => mod.HomeLoggedOut,
    );
    return promise;
  },
  { ssr: true, loading: () => null },
);

export default function Home() {
  const { appUser } = useAuth();
  return (
    <>
      <SEOHead title="Meki · Farmacia a domicilio" />
      {appUser ? <HomeLoggedIn /> : <HomeLoggedOut />}
    </>
  );
}
